document.addEventListener("DOMContentLoaded", function () {
  const heroSections = document.querySelectorAll(".hero-banner");

  if (!heroSections.length) return;

  heroSections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const autoplayDelay = parseInt(section.dataset.autoplayDelay, 10) || 4000;
    const enableAutoplay = section.dataset.enableAutoplay === "true";
    const enableLoop = section.dataset.enableLoop === "true";
    const pauseOnHover = section.dataset.pauseOnHover === "true";
    const showNavigation = section.dataset.showNavigation === "true";
    const showPagination = section.dataset.showPagination === "true";
    const effect = section.dataset.effect || "slide";
    const transitionSpeed =
      parseInt(section.dataset.transitionSpeed, 10) || 800;
    const grabCursor = section.dataset.grabCursor === "true";
    const enableKeyboard = section.dataset.enableKeyboard === "true";
    const enableMousewheel = section.dataset.enableMousewheel === "true";

    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl || typeof Swiper === "undefined") return;

    const originalSlides = swiperEl.querySelectorAll(".swiper-slide");
    const totalSlides = originalSlides.length;

    const swiperConfig = {
      direction: "horizontal",
      loop: enableLoop,
      centeredSlides: true,
      effect,
      speed: transitionSpeed,
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor,
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
      keyboard: {
        enabled: enableKeyboard,
      },
      mousewheel: {
        enabled: enableMousewheel && totalSlides > 1,
      },
      on: {
        init: function () {
          if (showPagination) {
            initializeProgressBars(this);
          }
        },
      },
    };

    if (enableAutoplay) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };
    }

    if (showNavigation) {
      swiperConfig.navigation = {
        nextEl: section.querySelector(".hero-swiper-button-next"),
        prevEl: section.querySelector(".hero-swiper-button-prev"),
      };
    }

    const swiper = new Swiper(swiperEl, swiperConfig);

    function initializeProgressBars(swiperInstance) {
      const paginationEl = section.querySelector(".custom-pagination");
      if (!paginationEl || totalSlides === 0) return;

      const progressBars = [];

      paginationEl.innerHTML = "";

      for (let i = 0; i < totalSlides; i++) {
        const progressBar = document.createElement("div");
        progressBar.classList.add("progress-bar");
        paginationEl.appendChild(progressBar);
        progressBars.push(progressBar);
      }

      const totalGap = 12 * (totalSlides - 1);
      const totalPadding = 16;
      const availableWidth = window.innerWidth - totalGap - totalPadding;
      const barWidth = availableWidth / totalSlides;

      progressBars.forEach((bar) => {
        bar.style.flex = `0 0 ${barWidth}px`;
        bar.style.minWidth = `${barWidth}px`;
      });

      function updateProgressAnimation() {
        const styleId = "progress-animation-" + sectionId;
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
          styleEl = document.createElement("style");
          styleEl.id = styleId;
          document.head.appendChild(styleEl);
        }

        styleEl.textContent = `
          #hero-${sectionId} .progress-bar.active::before {
            animation: fillProgress-${sectionId} linear forwards ${autoplayDelay}ms;
          }

          @keyframes fillProgress-${sectionId} {
            0% {
              width: 0;
            }
            100% {
              width: 100%;
            }
          }
        `;
      }

      updateProgressAnimation();

      function updateProgressBars(index) {
        const realIndex = index >= 0 && index < totalSlides ? index : 0;

        progressBars.forEach((bar, i) => {
          bar.classList.remove("active");

          if (i < realIndex) {
            bar.classList.add("completed");
          } else {
            bar.classList.remove("completed");
          }
        });

        const currentBar = progressBars[realIndex];
        if (currentBar) {
          currentBar.classList.remove("completed");
          void currentBar.offsetWidth;
          currentBar.classList.add("active");
        }
      }

      updateProgressBars(swiperInstance.realIndex);

      swiperInstance.on("slideChange", function () {
        updateProgressBars(this.realIndex);
      });

      const resizeHandler = function () {
        const newAvailableWidth = window.innerWidth - totalGap - totalPadding;
        const newBarWidth = newAvailableWidth / totalSlides;

        progressBars.forEach((bar) => {
          bar.style.flex = `0 0 ${newBarWidth}px`;
          bar.style.minWidth = `${newBarWidth}px`;
        });
      };

      window.addEventListener("resize", resizeHandler);
    }
  });

});
